import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './InfoBox.scss';

export default class InfoBox extends Component {
	static propTypes = {
		children: PropTypes.any.isRequired,
		type: PropTypes.oneOf(['info', 'warn', 'danger', 'success']).isRequired,
		className: PropTypes.string,
	};

	static defaultProps = {
		className: '',
	};

	render() {
		return (
			<div className={`InfoBox bg-${this.props.type} ${this.props.className}`}>
				{React.Children.toArray(this.props.children)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/InfoBox/index.js